<template>
    <modal-template ref="modal">
        <template v-slot:title>
            {{ lang.auth.register }}
        </template>

        <template v-slot:default>
            <h2 class="text-lg" v-html="msgBody"></h2>
            <div class="mt-4">
                <plain-button
                    href="/register"
                >{{ lang.labels.register }}</plain-button>
            </div>
        </template>

        <template v-slot:footer="footerSlotProps">
            <h4 v-html="footerText" class="text-center"></h4>
        </template>

    </modal-template>
</template>

<script setup>
import { ref, computed } from "vue";
import ModalTemplate from "./ModalTemplate";
import PlainButton from "../buttons/PlainButton";

const props = defineProps({
    lang: Object,
    modalData: Object,
});

const modal = ref(null);
const msg = ref("");

/**
 * track event for google analytics
 */
const trackGAEvent = (category, action, label) => {
    // gtag
    if (typeof gtag !== "undefined") {
        gtag("event", action, {
            event_category: category,
            event_label: label,
        });
    } else {
        console.log("GA tracking 2", category, action, label);
    }
};

/**
 * write event log and track in Google Analytics
 */
const writeLogs = () => {
    let category = "modal";
    let action = "please register";
    let label = props.modalData.modalTrigger;

    trackGAEvent(category, action, label);
};

const showModal = () => {
    modal.value.showModal();
    writeLogs();
};

const hideModal = () => {
    modal.value.hideModal();
};

/**
 * msg body
 * @return seting
 */
const msgBody = computed(() => {
    let msgBody = props.lang.auth["register_msg_" + props.modalData.modalTrigger];
    return msgBody;
});

/**
 * footer text
 */
const footerText = computed(() => {
    let currentUrl = window.location.pathname + window.location.search;
    let currentUrlEncoded = encodeURIComponent(currentUrl);
    let loginUrl = `/login?redirectTo=${currentUrlEncoded}`;
    let text = props.lang.auth.already_a_member;
    text = text.replace(":loginUrl", loginUrl);

    return text;
});

defineExpose({
    showModal,
    hideModal,
});
</script>
